/**
 * Encode a string with HTML entities
 * @param rawStr the string to encode
 * @returns the encoded result
 */
export const encodeHTMLEntities = (rawStr: string) =>
  rawStr.replace(/[\u00A0-\u9999<>&]/g, (i) => `&#${i.charCodeAt(0)};`).replace(/@/g, '&#64;');
